import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTitle } from "../../hooks/useTitle";
import { Paths } from "../../paths";
import CategoriesService from "../../http/CategoriesService";
import ObjectService from "../../http/ObjectService";
import Loading from "../../components/Loading";
import { Card, Col, Row } from "react-bootstrap";
import {useAuth} from "../../store/AuthContext";

const Admin: React.FC = () => {
    useTitle("Главная");

    const { isAuth, isLoading } = useAuth();

    const [loading, setLoading] = useState<boolean>(true);
    const [counts, setCounts] = useState({
        categories: 0,
        objects: 0,
        ankets: 0
    });

    useEffect(() => {
        const fetchData = async () => {
            if (isLoading || !isAuth) return;

            setLoading(true);
            try {
                // Запускаем все запросы параллельно для скорости
                const [categories, objects, ankets] = await Promise.all([
                    CategoriesService.query({ options: { where: { action: null } } }),
                    ObjectService.query({ options: { where: { action: null } } }),
                    ObjectService.queryAnketa({ options: { where: { action: null } } })
                ]);

                setCounts({
                    categories: categories.data.length,
                    objects: objects.data.length,
                    ankets: ankets.data.length
                });
            } catch (err: any) {
                console.error("Ошибка загрузки дашборда:", err.message);
            } finally {
                setLoading(false);
            }
        };

        void fetchData();
    }, [isAuth, isLoading]);


    if (isLoading || loading) {
        return <Loading />;
    }

    return (
        <div>
            <h4 className={"mb-3"}>Главная</h4>
            <Row>
                <Col lg={"3"} className={"mb-3"}>
                    <Card>
                        <Card.Header className={"h6 bg-white py-3 d-flex jc-center"}>Категории</Card.Header>
                        <Card.Body className={"d-flex ai-center jc-center"}>
                            <div className={"h3"}>{counts.categories}</div>
                        </Card.Body>
                        <Card.Footer>
                            <Link to={Paths.user_categories} className={"btn btn-link jc-center"}>
                                Перейти
                            </Link>
                        </Card.Footer>
                    </Card>
                </Col>

                <Col lg={"3"} className={"mb-3"}>
                    <Card>
                        <Card.Header className={"h6 bg-white py-3 d-flex jc-center"}>Объекты</Card.Header>
                        <Card.Body className={"d-flex ai-center jc-center"}>
                            <div className={"h3 mb-0"}>{counts.objects}</div>
                        </Card.Body>
                        <Card.Footer>
                            <Link to={Paths.user_objects} className={"btn btn-link jc-center"}>
                                Перейти
                            </Link>
                        </Card.Footer>
                    </Card>
                </Col>
                <Col lg={"3"} className={"mb-3"}>
                    <Card>
                        <Card.Header className={"h6 bg-white py-3 d-flex jc-center"}>Анкеты объектов</Card.Header>
                        <Card.Body className={"d-flex ai-center jc-center"}>
                            <div className={"h3"}>{counts.ankets}</div>
                        </Card.Body>
                        <Card.Footer>
                            <Link to={Paths.user_object_ankets} className={"btn btn-link jc-center"}>
                                Перейти
                            </Link>
                        </Card.Footer>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default Admin;
